import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "flowbite-react";
import { useLmcUserView } from "../../../../contexts/AuthContext";
import { CustomButton } from "../../../atoms/CustomButton";
import { useUserResendEmailVerification } from "../../../../hooks/users";
import { Timer } from "../../../../utils/Timer";

const LmcVerifyEmail = ({
  userId,
  showConfirmEmailModal,
  userEmail,
  userPassword,
  handleLogin,
  isLoading,
  onClose,
}: {
  userId: string;
  showConfirmEmailModal: boolean;
  userEmail: string;
  userPassword?: string;
  handleLogin: (data: { user_email: string; user_password: string }) => void;
  isLoading: boolean;
  onClose?: () => void;
}) => {
  const { t } = useTranslation("clientView");

  const [showTimer, setShowTimer] = useState(false);

  const {
    state: {
      entity: { entity_data },
    },
  } = useLmcUserView();

  const { mutate: resendEmail, isLoading: isResending } =
    useUserResendEmailVerification();

  return (
    <Modal show={showConfirmEmailModal} size="lg" dismissible onClose={onClose}>
      <Modal.Body className=" flex-col bg-gray-800 rounded-md justify-center items-center gap-5 inline-flex">
        <img
          title="Super User Manager"
          loading="lazy"
          src="https://cdn.1cdn.app/application/UMD/umd_verify_your_email.svg"
          alt="Super User Manager"
          className=""
          width={217}
        />
        <div className="flex-col justify-center items-center gap-2 inline-flex">
          <h2 className="text-center text-gray-200 text-2xl font-bold font-figtree leading-loose">
            {t("register.confirmEmailModal.text_1")}
          </h2>
          <p className="text-center text-gray-200 text-sm font-normal font-figtree leading-tight">
            {t("register.confirmEmailModal.text_3")} <b> {userEmail}</b>{" "}
            {t("register.confirmEmailModal.text_4")}
          </p>
        </div>

        <div className="flex justify-center items-center gap-3">
          <CustomButton
            variant="gray"
            onClick={() =>
              userEmail &&
              resendEmail(
                {
                  entity_identification: entity_data?.entity_identification,
                  userId: userId,
                },
                {
                  onSuccess: () => {
                    setShowTimer(true);
                  },
                  onError: (err) => {
                    setShowTimer(false);
                  },
                }
              )
            }
            disabled={showTimer}
            isLoading={isResending}
            title={t("register.confirmEmailModal.btn_2") as string}
            comp={
              showTimer && (
                <span className="text-muted ms-2">
                  <Timer setShowTimer={setShowTimer} ttl={120} />{" "}
                  {t("register.confirmEmailModal.text_5")}
                </span>
              )
            }
          />
          <CustomButton
            variant="primary"
            onClick={() =>
              handleLogin({
                user_email: userEmail,
                user_password: userPassword || "",
              })
            }
            disabled={isLoading}
            isLoading={isLoading}
            title={t("register.confirmEmailModal.btn_1") as string}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default LmcVerifyEmail;
